"use client";
import { Separator } from "@/components/ui/separator";
import Trophy from "./trophy";

type CardProps = {
  title: string;
  description: string;
};

export default function MobileCard(props: CardProps) {
  const { title, description } = props;

  return (
    <div className="h-full max-h-[320px] rounded-[20px] border border-secondary/10 px-10 py-10">
      <div className="">
        <div className="flex flex-col items-start gap-4">
          <div className="flex items-center gap-4">
            <Trophy />
            <p className="w-[130px] text-xl ltr:font-playfair">{title}</p>
          </div>
          <Separator className="bg-secondary/20" />
          <div className="text-secondary/60">{description}</div>
        </div>
      </div>
    </div>
  );
}
